var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Snackbar'),_c('Dialog'),(_vm.doMainIframeExist)?_c('iframe',{staticClass:"hidden-iframe",staticStyle:{"display":"none"},attrs:{"id":"sr_iframe_localstorage","src":_vm.$axios.defaults.baseURL}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }